import React from "react"
import { Col } from "reactstrap"
import { Field } from "lib/formik"
import TextError from "components/Shared/TextError"
import Switch from "components/Shared/Switch"

const CountryTaxDetails = ({
  touched,
  errors,
  t,
  setFieldValue,
  values,
  submitCount = 0,
}) => {
  const fields = [
    { name: "title", label: t("Name(English)") },
    { name: "titleAr", label: t("Name(عربي)"), rtl: true },
    { name: "value", label: t("Tax Rate (in %)") },
    { name: "registeredNo", label: t("Registered No") },
  ]

  return (
    <>
      {fields.map(field => {
        const showInvalid =
          Boolean(errors[field.name]) &&
          (Boolean(touched[field.name]) || submitCount > 0)

        return (
          <Col lg={6} key={field.name}>
            <div className="form_field">
              <label htmlFor={field.name}>
                <span className="text-danger">*</span> {field.label}
              </label>
              <Field
                type="text"
                id={field.name}
                name={field.name}
                placeholder={field.label}
                className={`form-control ${showInvalid ? "is-invalid" : ""}`}
                style={field.rtl ? { direction: "rtl" } : {}}
              />
              <TextError name={field.name} />
            </div>
          </Col>
        )
      })}

      <Col
        lg={6}
        className="mb-3 d-flex align-items-center justify-content-start"
      >
        <label className="mb-0 me-2" htmlFor="isCountryLocal">
          {t("Is Country Local")}
        </label>
        <Switch
          isChecked={Boolean(values?.isCountryLocal)}
          onClickHandler={() =>
            setFieldValue("isCountryLocal", !values?.isCountryLocal)
          }
        />
      </Col>
    </>
  )
}

export default CountryTaxDetails
